/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { createMuiTheme, MuiThemeProvider, Paper, TableCell, Tooltip, Typography, withStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';

import api from '../../api';
import CloseImage from '../../../assets/ic_close.png';
import icPanggil from '../../../assets/ic_call.png';
import icPanggilManual from '../../../assets/ic_manualCall.png';
import icCircleBlue from '../../../assets/ic_circle_blue.png';
import icCircleGreen from '../../../assets/ic_circle_light_green.png';
import { usePiPWindow } from '../../components/pip/pip_provider';
import PiPWindow from '../../components/pip/pip_window';
import AntrianPIPPage from '../../components/antrian/AntrianPIPPage';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const options = {
    filterType: 'multiselect',
    fixedHeader: true,
    filter: false,
    search: true,
    sort: true,
    print: false,
    download: false,
    selectableRows: false,
    viewColumns: false,
    rowsPerPage: 10,
    responsive: 'scrollMaxHeight',

};

const ct = require("../../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTablePemanggilan());

const TabAntrian = ({
    handleTotalData,
    setLoading,
    loading,
    setOpenAlert,
    openAlert,
    setMessageAlert,
    messageAlert,
    setStatusAlert,
    propsPip,
    indexTab,
}) => {
    const {
        isSupported,
        requestPipWindow,
        pipWindow,
        closePipWindow
    } = usePiPWindow()

    const [data, setData] = useState([])
    const [rawData, setRawData] = useState(null)
    const [newNotes, setNewNotes] = useState("")
    const [visibleStop, setVisibleStop] = useState(false)
    const [statusAntrian, setStatusAntrian] = useState("")
    const [dokterScheduleID, setDokterScheduleID] = useState("")
    const [dokterScheduleDetailID, setDokterScheduleDetailID] = useState("")
    const location = useLocation();

    const startPiP = useCallback(() => {
        requestPipWindow(1000, 550)
    }, [requestPipWindow])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const getDetailPasien = (id, scheduleID) => {
        api.create().getDetailPasienPemanggilan(id, scheduleID).then(res => {
            if (res.data && res.data.data != null) {
                let data = res.data.data
                setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                setDokterScheduleID(data.doctor_schedule_id)
                setStatusAntrian(data.queue_status_name === "Menunggu" ? "Next" : data.queue_status_name === "Dilewati" || data.queue_status_name === "Ditunda" ? "Next" : data.queue_status_name === "Darurat" || data.queue_status_name === "Dipanggil" ? "Next" : "Proses")
                setLoading(false)
                forceUpdate()
            } else {
                setLoading(false)
            }
        })
    }

    const getDataAntrian = async () => {
        let response = null
        if (indexTab === 1) {
            response = await api.create().getListAntrianSkip(location.state.doctorID, location.state.scheduleID)
        } else {
            response = await api.create().getListAntrian(location.state.doctorID, location.state.scheduleID)
        }

        if (response.data) {
            if (response.data.status === true && response.data.data != null) {
                let dataAntrian = response.data.data.map((item, index) => {
                    return [
                        item.queue_number,
                        item.patient_name,
                        item.patient_gender,
                        item.booking_id,
                        item.checkin_at === null ? "" : format(new Date(item.checkin_at), 'dd MMM yyyy HH:mm'),
                        item.is_called === 1 && (item.queue_status_name === "Darurat" || item.queue_status_name === "Menunggu" || item.queue_status_name === "Ditunda") ? "Dipanggil" : item.is_called === 1 && item.queue_status_name === "Dilayani" ? "Dilayani" : item.queue_status_name === "Dilewati" ? "Dilewati" : item.queue_status_name,
                    ]
                })
                if (response.data.data.length > 0) {
                    if (response.data.data[0].is_called === 1 || response.data.data[0].queue_status_id === 2) {
                        let id = response.data.data[0].patient_id
                        let scheduleID = response.data.data[0].doctor_schedule_detail_id
                        getDetailPasien(id, scheduleID)
                    }
                }
                setData(dataAntrian)
                setRawData(response?.data?.data || [])
                handleTotalData(response?.data?.total_data || 0, indexTab)
                setLoading(false)
            } else {
                setData([])
                setRawData(null)
                handleTotalData(response?.data?.total_data || 0, indexTab)
                setLoading(false)
            }
        }
    }

    const getDataAntrianTerlewati = () => {
        api.create().getListAntrianSkip(location.state.doctorID, location.state.scheduleID).then(response => {
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    handleTotalData(response?.data?.total_data || 0, 1)
                    setLoading(false)
                } else {
                    handleTotalData(response?.data?.total_data || 0, 1)
                    setLoading(false)
                }
            }
        })
    }

    const handleCall = ({ doctor_schedule_id, doctor_schedule_detail_id }) => {
        setLoading(true)
        let payload = {
            doctor_schedule_id,
            doctor_schedule_detail_id,
            "status": "CALL"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                    setDokterScheduleID(data.doctor_schedule_id)
                    setStatusAntrian("Next")
                    getDataAntrian()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleCallManual = ({ doctor_schedule_id, doctor_schedule_detail_id }) => {
        setLoading(true)
        let payload = {
            doctor_schedule_id,
            doctor_schedule_detail_id,
            "status": "CALL",
            "without_call": 1
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                    setDokterScheduleID(data.doctor_schedule_id)
                    setStatusAntrian("Next")
                    getDataAntrian()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleNextPatient = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": location.state.scheduleID,
            "doctor_schedule_detail_id": null,
            "status": "NEXT"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data === true) {
                        getDataAntrian()
                        alert('Antrian tidak tersedia')
                    } else {
                        getDataAntrian()
                        let data = response.data.data
                        setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                        setDokterScheduleID(data.doctor_schedule_id)
                        setStatusAntrian("Next")
                        forceUpdate()
                    }
                } else {
                    if (response.data) {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("warning")
                        }
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleStart = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "new_notes": newNotes,
            "status": "START"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setTimeout(() => {
                        getDataAntrian()
                    }, 300);
                    setStatusAntrian("Proses")
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleStop = (_newNotes) => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "new_notes": _newNotes || newNotes,
            "status": "DONE"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setStatusAntrian("")
                    setNewNotes("")
                    getDataAntrian()
                    setVisibleStop(false)
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleSkip = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "status": "SKIP"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setStatusAntrian("")
                    getDataAntrian()
                    getDataAntrianTerlewati()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleHold = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "new_notes": newNotes,
            "status": "HOLD"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setStatusAntrian("")
                    getDataAntrian()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    useEffect(() => {
        setDefaultData()
    }, [indexTab])

    useEffect(() => {
        getDataAntrianTerlewati()
    }, [])

    const setDefaultData = () => {
        getDataAntrian()
        setData([])
        setRawData([])
        setNewNotes("")
        setStatusAntrian("")
        setDokterScheduleID("")
        setDokterScheduleDetailID("")
        closePipWindow()
    }

    const columns = [
        {
            name: "No. Antrian",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    const { is_called, queue_status_id } = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: is_called === 1 || queue_status_id === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Nama Pasien",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    const { is_called, queue_status_id } = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: is_called === 1 || queue_status_id === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Jenis Kelamin",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    const { is_called, queue_status_id } = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: is_called === 1 || queue_status_id === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "ID Reservasi",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    const { is_called, queue_status_id } = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: is_called === 1 || queue_status_id === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Check In",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    const { is_called, queue_status_id } = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: is_called === 1 || queue_status_id === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Status",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    const { is_called, queue_status_id } = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: is_called === 1 || queue_status_id === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    const _item = rawData?.[tableMeta.rowIndex] || {}
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {statusAntrian === "" || (statusAntrian === "Next" && _item?.is_called === 1) ?
                                <LightTooltip title={"Panggil"} arrow>
                                    <div
                                        onClick={() => statusAntrian === "" || (statusAntrian === "Next" && _item?.is_called === 1) ? handleCall(_item) : null}
                                        style={{ backgroundImage: `url(${icCircleGreen})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10, cursor: 'pointer' }}>
                                        <img src={icPanggil} style={{ width: 20, height: 20 }} alt='icPanggil' />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                            {statusAntrian === "" || (statusAntrian === "Next" && _item?.is_called === 1) ?
                                <LightTooltip title={"Panggil Manual"} arrow>
                                    <div
                                        onClick={() => statusAntrian === "" || (statusAntrian === "Next" && _item?.is_called === 1) ? handleCallManual(_item) : null}
                                        style={{ backgroundImage: `url(${icCircleBlue})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        <img src={icPanggilManual} style={{ width: 20, height: 20 }} alt='icPanggilManual' />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                        </div>
                    )
                }
            }
        }
    ];

    return (
        <>
            <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                {data?.length === 0 ? null : <div style={{ display: 'flex' }}>
                    {statusAntrian === "" ?
                        <button
                            style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094FF', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                            onClick={() => handleNextPatient()}
                        >
                            <Typography style={{ color: 'white' }}>Antrian Selanjutnya</Typography>
                        </button>
                        : statusAntrian === "Next" ?
                            <div style={{ display: 'flex' }}>
                                <button
                                    style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#4CDC63', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                    onClick={() => handleStart()}
                                >
                                    <Typography style={{ color: 'white' }}>Start</Typography>
                                </button>
                                <button
                                    style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#EDD60A', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                    onClick={() => handleSkip()}
                                >
                                    <Typography style={{ color: 'white' }}>Lewati</Typography>
                                </button>
                            </div>
                            : statusAntrian === "Proses" ?
                                <div style={{ display: 'flex' }}>
                                    <button
                                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FFA654', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                        onClick={() => handleHold()}
                                    >
                                        <Typography style={{ color: 'white' }}>Hold</Typography>
                                    </button>
                                    <button
                                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FF5B5B', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                        onClick={() => setVisibleStop(true)}
                                    >
                                        <Typography style={{ color: 'white' }}>Stop</Typography>
                                    </button>
                                </div>
                                : null
                    }
                    <div style={{ position: 'absolute', right: 55, }}>
                        {isSupported && <button
                            style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094FF', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10, alignItems: 'flex-end', float: 'right' }}
                            onClick={pipWindow ? closePipWindow : startPiP}
                        >
                            <Typography style={{ color: 'white' }}>Open PIP</Typography>
                        </button>}
                    </div>
                </div>}

                {!loading && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                )}

                {pipWindow && (
                    <PiPWindow pipWindow={pipWindow}>
                        {/* <div className="pipRoot">{counterComponent}</div> */}
                        <div className="pipRoot">
                            {<AntrianPIPPage
                                {...propsPip}
                                dataAntrian={rawData}
                                docterName={location.state.doctorName}
                                polyclinic={location.state.polyclinic}
                                onCall={handleCall}
                                statusAntrian={statusAntrian}
                                onStart={handleStart}
                                onHold={handleHold}
                                onSkip={handleSkip}
                                onStop={handleStop}
                                loading={loading}
                                openAlert={openAlert}
                                messageAlert={messageAlert}
                            />}
                        </div>
                    </PiPWindow>
                )}

                {visibleStop && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setVisibleStop(false)
                                        }}
                                    >
                                        <img src={CloseImage} alt='CloseImage' />
                                    </button>
                                </div>
                            </div>
                            <div style={{ height: '30vh' }}>
                                <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>Catatan Baru</Typography>
                                <textarea
                                    label="Catatan Petugas"
                                    value={newNotes}
                                    onChange={(e) => {
                                        setNewNotes(e.target.value)
                                    }}
                                    style={{ width: '70%', marginTop: 10, height: '15vh' }}
                                    placeholder={"input catatan baru"}
                                />
                                <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                                    <div
                                        onClick={() => handleStop()}
                                        style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Paper>
        </>
    )
}

export default TabAntrian